import { render, staticRenderFns } from "./bodyLeftTop.vue?vue&type=template&id=6a540086&scoped=true"
import script from "./bodyLeftTop.vue?vue&type=script&lang=js"
export * from "./bodyLeftTop.vue?vue&type=script&lang=js"
import style0 from "./bodyLeftTop.vue?vue&type=style&index=0&id=6a540086&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a540086",
  null
  
)

export default component.exports